
/**
 * Reveal on viewport
 * @module SpriteTitle
 *
 * @param {object} options
 * @property {number} offset between 0 and 1
 * @property {boolean} once
 *
 * @return {function} onenter
 * @return {function} onleave
 */

/* eslint-disable */
const SpriteTitle = el => {
    const imgs = [];
	var inc = 0;
	var loaded = 0;
	const picture = el.querySelector('picture');
	const src = el.dataset.src;
	const length = el.dataset.length;
	const sufixe = el.dataset.sufixe;
	const sources = picture.querySelectorAll('source');
	const start = () => {
		const int = setInterval(() => {
			inc++;
			sources[0].setAttribute('srcset',`${src}${sufixe}-mobile/${inc}.png`);
			sources[1].setAttribute('srcset',`${src}${sufixe}-desktop/${inc}.png`);
			inc == length - 1 && clearInterval(int);
		}, 40);	
	}
	for(let i = 0; i< length; i++){
		const img = new Image();
		img.src = `${src}${sufixe}-desktop/${i}.png`;
		img.onload = () => {
			loaded++;
			loaded == length && start();
		}
	}
};

export default SpriteTitle;
